import api from "@/core/services/api.service";

class tutorialError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const TutoService = {
    async Tutorials() {
        try {
            api.setHeader();
            const response = await api.get("api", "tutorials");
            return response;
        } catch (error) {
            throw new tutorialError(error.response.status, error.response)
        }
    },
}

export default TutoService
export { TutoService, tutorialError }